import './course-detail-top.scss'
import { useHistory } from 'react-router-dom'
import React from 'react'
interface ICourseDetailTop{
  courseName?: string;
  courseImage?: string;
  organization?: string;
}
export const CourseDetailTop = (props: ICourseDetailTop) => {
  const history = useHistory();
  return (<div className="cd-top">
    <div
      className="cd-image"
      style={props?.courseImage?{
        backgroundImage: `url(${props?.courseImage})`
      }:{}}
    ></div>
    <div className="cd-top-content"></div>
  </div>)
}
